import { withStyles } from '@material-ui/core';
import { useState, useEffect } from 'react';
import constants from '../../../../constants';
import RenderMap from './components/RenderMap';

const styles = (_theme) => ({
  container: {
    display: 'flex',
    columnGap: '4px',
    justifyContent: 'space-between',
    flex: 1,
    marginRight: 24,
    marginBottom: 12
  },
});

const getKPIBeforePickupAssignment = (currentRoutePreview, driverRouteKPI) => {
  if (currentRoutePreview.length === 0) return { totalStops: 0 };
  return driverRouteKPI;
};

const MapContainer = ({
  classes,
  mapConfig,
  glEventHub,
  unassignedPickups,
  driverRoutePreview: {
    currentRoutePreview = [],
    recommendedRoutePreview = [],
    currentDriverRouteKPI = {},
    recommendedDriverRouteKPI = {}
  } = {}
}) => {
  const [maximizedMap, setMaximizedMap] = useState(null);
  useEffect(() => {
    glEventHub.emit('mapResize');
  }, [mapConfig.loading, maximizedMap]);

  const toggleMaximize = (mapId) => {
    setMaximizedMap((prev) => (prev === mapId ? null : mapId));
  };

  const commonProps = {
    maximizedMap,
    toggleMaximize,
    mapConfig,
    glEventHub
  };
  return (
    <div className={classes.container}>
      {/* Before Pickup Assignment */}
      <RenderMap
        mapId={constants.MAP_HEADER.BeforePickupAssignment.MAP_ID}
        selectedRoutes={currentRoutePreview}
        unassignedPickups={unassignedPickups}
        driverKpiData={getKPIBeforePickupAssignment(currentRoutePreview, currentDriverRouteKPI)}
        headerLabel={constants.MAP_HEADER.BeforePickupAssignment.MAP_HEADER_LABEL}
        {...commonProps}
      />

      {/* After Pickup Assignment */}
      <RenderMap
        mapId={constants.MAP_HEADER.AfterPickupAssignment.MAP_ID}
        selectedRoutes={recommendedRoutePreview}
        unassignedPickups={[]}
        driverKpiData={recommendedDriverRouteKPI}
        headerLabel={constants.MAP_HEADER.AfterPickupAssignment.MAP_HEADER_LABEL}
        shouldShowRoutePreview={mapConfig.isFeasibleOption} // Route Preview is not shown if the recommended driver route is not feasible
        {...commonProps}
      />
    </div>
  );
};

export default withStyles(styles)(MapContainer);
